import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { FeaturesFormContext } from "../../contexts/features-form-context";
import { FeatureEnum } from "../../types/feature";
import { isHumanType } from "../../types/guards/features";

import HumanForm from "../../components/forms/HumanForm";

type FeaturesFormSwitcherProps = {
  featureType: string | FeatureEnum;
  data: unknown;
  objName : string;
  updateObjName : (value : string) => void;
  valueFormChange: (value: unknown) => void;
}

const FeaturesFormSwitcher = ({data, featureType, objName, updateObjName, valueFormChange}: FeaturesFormSwitcherProps) => {
  const intl = useIntl();
  const [formData, updateFormData] = useState<unknown>();
  
  useEffect(() => {    
    valueFormChange(formData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData])

  const updateFeatureForm = useCallback((value:unknown) => {
    updateFormData(value ? {...value} : null);
  }, [])

  return (
    <FeaturesFormContext.Provider value={{formData, updateFeatureForm}}>
      <form>
        <div className="mb-5">
          <label className="mt-1.5 block text-shadow text-sm" htmlFor="objName">
            {intl.formatMessage({ id: 'forms.objectName' })}
          </label>
          <div className="flex gap-5 items-center">
            <div className="w-full lg:w-1/2 flex gap-2.5 items-center">
              <input id="objName" type="text"
                placeholder={intl.formatMessage({ id: 'forms.objectNamePlaceholder' })}
                autoComplete="off"
                value={objName}   
                onChange={(e) => updateObjName(e.target.value)}          
                className="w-full input-sm"/>          
            </div>        
          </div>
        </div>
        {
          featureType === FeatureEnum.Human && (data === null || isHumanType(data)) ? (
            <HumanForm  data={data} />
          ) : <h2>{intl.formatMessage({ id: 'forms.noMatchingForm' })}</h2>
        }
      </form>
    </FeaturesFormContext.Provider>
  )
}

export default FeaturesFormSwitcher;
